import React from 'react'
import { Mutation, ApolloConsumer } from 'react-apollo'
import { SIGNUP } from 'operations/User'
import { Input, Submit, Fieldset } from 'components/Form'
import { Link } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import { withRouter } from 'react-router'

function getQueryStringParams (query) {
    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query)
            .split('&')
            .reduce((params, param) => {
                    let [key, value] = param.split('=');
                    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                    return params;
                }, {}
            )
        : {}
}

class SignUp extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            email: getQueryStringParams(this.props.location.search).email || '',
            error: ''
        }
    }

    handleChange(e) {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    

    render() {

        const { email } = getQueryStringParams(this.props.location.search)
        if (email && this.state.email.length < 1) {
            this.setState({email})
        }
        
        const errors = {
            USER_EXISTS: `Sorry, that user already exists. Please log in.`,
            DEFAULT: `Sorry, we're having trouble signing you up.`
        }

        return(
            <ApolloConsumer>
                {client => (

                    <Mutation mutation={ SIGNUP }>
                    {(signUp, { data }) => (

                        <form onSubmit={
                            (e) => {
                                e.preventDefault()
                                signUp({ variables: { data: { firstName: this.state.firstName, lastName: this.state.lastName, email: this.state.email } } })
                                .then(({ data }) => {
                                    localStorage.setItem('accessToken', data.createAccount.accessToken)
                                    localStorage.setItem('refreshToken', data.createAccount.refreshToken)
                                    const decoded = jwtDecode(data.createAccount.accessToken)
                                    localStorage.setItem('tokenExpiry', decoded.exp)
                                    client.writeData({ data: { isAuthenticated: true } })
                                    this.props.history.push('/')
                                })
                                .catch(err => {
                                    console.log(err.message)
                                    this.setState({
                                        error: err.message.replace("GraphQL error: ", "")
                                    })
                                })
                            }
                        }>

                            {/* <div className='unauthorized__tagline'> */}
                            <h2>Get started in seconds</h2>
                            <h1>Sign up for an account</h1>
                            {/* </div> */}

                            {/* <div className='unauthorized__card'> */}

                            <Fieldset legend='No credit card required'>

                                <Input type='text' name='firstName' label='First Name' onChange={ this.handleChange.bind(this) } />
                                <Input type='text' name='lastName' label='Last Name' onChange={ this.handleChange.bind(this) } />

                                <Input type='text' name='email' label='Email' onChange={ this.handleChange.bind(this) } value={this.state.email} />

                                <div className='form__error'>{ this.state.error ? errors[this.state.error] ? errors[this.state.error] : errors.DEFAULT : '' }</div>

                                <Submit value='Sign up' />

                                <div className='form__switch'>
                                    Already have an account? <Link to='/'>Log In</Link>
                                </div>

                            </Fieldset>

                            {/* </div> */}

                        </form>
                    )}
                    </Mutation>

                )}
            </ApolloConsumer>
        )

    }

}

export default withRouter(SignUp)


// WEBPACK FOOTER //
// ./src/containers/Unauthorized/SignUp/index.js